export { default as InventoryInfo } from './InventoryInfo';

